module.exports = __webpack_public_path__ + "img/illust-company-section-about.6d5fd58e.png";